import { Adsense } from '@ctrl/react-adsense';

/**
 * Google AdSense component for displaying ads
 *
 * To configure:
 * 1. Replace 'ca-pub-XXXXXXXXXXXXXX' with your Google AdSense publisher ID
 * 2. Replace 'YYYYYYYYYY' with your ad slot ID
 * 3. For production, set adTest to 'off'
 */
function AdSenseBlock() {
  return (
    <div className="mt-auto pt-4 flex-shrink-0 overflow-hidden" style={{ height: '250px', maxHeight: '250px', minHeight: '250px' }}>
      <div className="w-full h-full overflow-hidden relative">
        <Adsense
          className="adsense-block"
          client="ca-pub-9100534541488467"
          slot="YYYYYYYYYY"
          style={{ display: 'block', width: '100%', height: '100%', maxHeight: '250px', overflow: 'hidden' }}
          format="auto"
          responsive="true"
          adTest="off"
        />
      </div>
    </div>
  );
}

export default AdSenseBlock;
